import React, { useEffect, useState } from "react";
import "./LoanProducts.scss";
import { Box, Button, TextField, Typography, MenuItem, TableRow, TableHead, Table, TableContainer, TableCell, IconButton, TableBody, TablePagination, Tabs, Tab } from "@mui/material";
import { commonRunQuery, listCurrencies, loansCreateProduct, loansUpdateProduct, loansDeleteProduct } from "../../../util/API/loans";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import EditIcon from "../../../images/editpencil.svg";
import LoanSetupTable from "../../../components/LoanSetupTable/LoanSetupTable";
import CustomLoansForm from "../../../components/UI/CustomLoansForm/CustomLoansForm";
import { useDispatch } from "react-redux";
import { setNewConstants } from "../../../store/redux/constants";
import BaseDrawer from "../../../components/UI/BaseDrawer/BaseDrawer";
import LoanTypes from "./LoanTypes/LoanTypes";
import { normalizeLoanProductRecord } from "./loanProductRecord";

const LoanProducts = ({setAlert, setAlertOpen, alert, categoryData}) => {
    const [categories, setCategories] = useState([]);
    const [loanProductsArr, setLoanProductsArr] = useState([]);
    const [loanCurrencyArr, setLoanCurrencyArr] = useState([]);
    const [loanTypesArr, setLoanTypesArr] = useState([]);
    const [formValues, setFormValues] = useState(null);
    const [viewMode, setViewMode] = useState("table");
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [openLoanTypesDrawer, setOpenLoanTypesDrawer] = useState(false);
    const [selectedProductId, setSelectedProductId] = useState(null);

    const dispatch = useDispatch();

    useEffect(()=> {
        getAllCategories();
        if(categoryData && categoryData !== null) {
            getCategorewiseLoanProducts();
        } else {
            getAllLoanProducts();
        }
        getAllLoanCurrencies();
    }, []);

    useEffect(()=> {
        console.log("categoryData---------------",categoryData);
    }, [categoryData])

    useEffect(()=> {
        dispatch(setNewConstants({ formSelectData: { category: categories, currencycode:loanCurrencyArr } }));
    },[categories, loanCurrencyArr]);

    const handleEdit = (rowData) => {
        console.log("rowData--------------",rowData);
        setSelectedProduct(rowData);
        setViewMode("edit");
    };

    const getAllCategories = async () => {
        try {
            const response = await commonRunQuery(265, "");
            if (
                response?.data?.header?.callStatus === "1" &&
                response?.data?.header?.reccount !== "0"
            ) {
                const rawCategories = Array.isArray(response?.data?.body?.record)
                    ? response?.data?.body?.record
                    : [response?.data?.body?.record];
    
                const formattedCategories = rawCategories.map((item) => {
                    const cat = item.loancategories;
                    return {
                        key: cat.categoryid,
                        value: cat.categoryid,
                        label: cat.name
                    };
                });
    
                setCategories(formattedCategories);
                console.log("formattedCategories=======================", formattedCategories);
                setFormValues({category:categories});
            } else {
                setCategories([]);
            }
        } catch (error) {
            console.log("getAllCategories_error=======================", error);
        }
    };

    const getAllLoanProducts = async() => {
        try {
            let response = await commonRunQuery(268, "");
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const rawLoanProducts = Array.isArray(response?.data?.body?.record) ? response?.data?.body?.record : [response?.data?.body?.record];
                const loanProductsArray = rawLoanProducts.map(normalizeLoanProductRecord);
                setLoanProductsArr(loanProductsArray);
                console.log("loanProductsArray=======================",loanProductsArray);
            } else {
                setLoanProductsArr([]);
            }
        } catch (error) {
            console.log("getAllCategories_error=======================",error);
        }
    }

    const getCategorewiseLoanProducts = async() => {
        try {
            let response = await commonRunQuery(274, categoryData?.categoryid );
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const rawLoanProducts = Array.isArray(response?.data?.body?.record) ? response?.data?.body?.record : [response?.data?.body?.record];
                const loanProductsArray = rawLoanProducts.map(normalizeLoanProductRecord);
                setLoanProductsArr(loanProductsArray);
                console.log("loanProductsArray=======================",loanProductsArray);
            } else {
                setLoanProductsArr([]);
            }
        } catch (error) {
            console.log("getAllCategories_error=======================",error);
        }
    }

    const getAllLoanCurrencies = async () => {
        try {
            let response = await listCurrencies("EN");
            if (
                response?.data?.header?.callStatus === "1" &&
                response?.data?.header?.reccount !== "0"
            ) {
                const rawCurrencies = Array.isArray(response?.data?.body?.record)
                    ? response?.data?.body?.record
                    : [response?.data?.body?.record];
    
                const formattedCurrencies = rawCurrencies.map((item) => {
                    const v = item.Vcurr;
                    return {
                        key: v.currCode,
                        value: v.currCode,
                        label: v.label,
                        // symbol: v.symbol,
                        // ...v
                    };
                });
    
                setLoanCurrencyArr(formattedCurrencies);
                console.log("formattedCurrencies=======================", formattedCurrencies);
            } else {
                setLoanCurrencyArr([]);
            }
        } catch (error) {
            console.log("getAllLoanCurrencies_error=======================", error);
        }
    };

    const handleSubmit = async(submittedValue) => {
        console.log("submittedValue----------",submittedValue?.productid?.toUpperCase());

        try {
            const response = await loansCreateProduct(
                submittedValue?.productid?.toUpperCase(), 
                submittedValue?.productname, 
                submittedValue?.category, 
                submittedValue?.currencycode, 
                submittedValue?.autoapprove,
                submittedValue?.minlimit || "0.00",
                submittedValue?.maxlimit || "0.00"
            );

            console.log("handleSubmit_error----------------", response)
            if(response?.data?.header?.callStatus === "1") {
                setAlert({
                    showAlert: true,
                    message: "Loan product created successfully.",
                    severity: "success",
                    header: "Success",
                });
                setAlertOpen(true);

                if(categoryData && categoryData !== null) {
                    getCategorewiseLoanProducts();
                } else {
                    getAllLoanProducts();
                }
                // getAllLoanProducts();
                setViewMode("table");
            } else if(response?.Status == '2' && response?.payload?.callStatus == "0") {
                setAlert({
                    showAlert: true,
                    message: response?.payload?.msg,
                    severity: "error",
                    header: "Error",
                });
            }
        } catch (error) {
            setAlert({
                showAlert: true,
                message: "There was an error in creating loan product. " + error,
                severity: "error",
                header: "Error",
            });
        }
    };

    const handleUpdate = async(submittedValue) => {
        try {
            const response = await loansUpdateProduct(
                selectedProduct?.lp?.productid, 
                submittedValue?.productname, 
                submittedValue?.category, 
                submittedValue?.currencycode, 
                submittedValue?.autoapprove,
                submittedValue?.minlimit || "0.00",
                submittedValue?.maxlimit || "0.00"
            );

            if(response?.data?.header?.callStatus === "1") {
                setAlert({
                    showAlert: true,
                    message: "Loan product updated successfully.",
                    severity: "success",
                    header: "Success",
                });
                setAlertOpen(true);

                if(categoryData && categoryData !== null) {
                    getCategorewiseLoanProducts();
                } else {
                    getAllLoanProducts();
                }
                // getAllLoanProducts();
                setViewMode("table");
            }
        } catch (error) {
            setAlert({
                showAlert: true,
                message: "There was an error in updating loan product. " + error,
                severity: "error",
                header: "Error",
            });
        }
    };

    const columns = [
        {
            label: 'Product Id',
            getValue: (row) => row?.lp?.productid ?? ''
        },
        {
            label: 'Name',
            getValue: (row) => row?.lp?.name?.toString().trim() ? row?.lp?.name : "-"
        },
        {
            label: 'Category Id',
            getValue: (row) => row?.lp?.categoryid ?? ''
        },
        {
            label: 'Category Name',
            getValue: (row) => row?.lc?.category_name ?? ''
        },
        {
            label: 'Currency Code',
            getValue: (row) => row?.lp?.currencycode ?? ''
        },
        {
            label: 'Auto Approve',
            getValue: (row) => row?.lp?.autoapprove == 1 ? 'Yes' : 'No'
        }
    ];

    const handleViewLoanTypes = async(rowData) => {
        console.log("handleViewLoanTypes_rowData=======================",rowData?.lp?.productid);
        setSelectedProductId(rowData?.lp?.productid);
        try {
            let response = await commonRunQuery(272, rowData?.lp?.productid);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const loanTypesArray = Array.isArray(response?.data?.body?.record) ? response?.data?.body?.record : [response?.data?.body?.record];
                setLoanTypesArr(loanTypesArray);
                console.log("loanTypesArray=======================",loanTypesArray);
                setOpenLoanTypesDrawer(true);
            } else {
                setLoanTypesArr([]);
                setOpenLoanTypesDrawer(true);
            }
        } catch (error) {
            console.log("getAllCategories_error=======================",error);
        }
    }

    const handleDeleteConfirmation = (rowData) => {
        console.log("handleDeleteConfirmation_rowData=======================",rowData);
        setAlert({
            ...alert,
            showAlert: true,
            message: `Are you sure you want to delete ${rowData?.lp?.name}?`,
            severity: "confirm",
            header: "Please Confirm",
            alertType: 'confirm',
            onConfirm: () => handleDelete(rowData)
        })
    }

    const handleDelete = async(rowData) => {
        console.log("handleDelete_rowData----------------",rowData?.lp?.productid);
        try {
            const response = await loansDeleteProduct("", rowData?.lp?.productid);
            console.log("handleDelete_response----------------",response);

            if(response?.data?.header?.callStatus === "1") {
                setAlert({
                    showAlert: true,
                    message: "Loan Product deleted successfully.",
                    severity: "success",
                    header: "Success",
                });
                setAlertOpen(true);

                if(categoryData && categoryData !== null) {
                    getCategorewiseLoanProducts();
                } else {
                    getAllLoanProducts();
                }
                // getAllLoanProducts();
                setViewMode("table");
            } else if(response?.Status == '2' && response?.payload?.callStatus == '0') {
                setAlert({
                    showAlert: true,
                    message: response?.payload?.msg,
                    severity: "error",
                    header: "Error",
                });
            }
        } catch (error) {
            setAlert({
                showAlert: true,
                message: "There was an error in deleting the loan product. " + error,
                severity: "error",
                header: "Error",
            });
        }
    }

    return (
        <Box sx={{ p: 2 }} className="loan-products-container">
            {viewMode !== "table" && (
                <Box>
                    <Box className="d-flex justify-content-between align-items-center mb-2">
                        <Typography variant="h6">
                            {viewMode === "create" ? "" : "Edit Loan Product"}
                        </Typography>
                        <Button
                            className="fs-size-12 paiy-blue text-white"
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                setViewMode("table");
                                setSelectedProduct(null);
                            }}
                        >
                            Return
                        </Button>
                    </Box>

                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, maxWidth: 500, mt: 2 }}>
                        <CustomLoansForm
                            formValues={viewMode === "edit" ? selectedProduct?.lp : null}
                            formName={viewMode === "edit" ? "createloanproducts" : "createloanproducts"}
                            buttonText={viewMode === "edit" ? "Update" : "Submit"}
                            loadingButtonText={viewMode === "edit" ? "Updating Product ..." : "Creating Product ..."}
                            onSubmit={viewMode === "create" ? handleSubmit : handleUpdate}
                            initialValues={{
                                productid: selectedProduct?.lp?.productid,
                                category: categoryData && categoryData !== null ? categoryData?.categoryid : selectedProduct?.lp?.categoryid,
                                productname: selectedProduct?.lp?.name,
                                currencycode: selectedProduct?.lp?.currencycode,
                                autoapprove: selectedProduct?.lp?.autoapprove,
                                minlimit: selectedProduct?.lp?.minlimit || "",
                                maxlimit: selectedProduct?.lp?.maxlimit || ""
                            }}
                            isEdit={viewMode == "edit" ? true : false}
                            isCreate={viewMode == "create" ? true : false}
                        />
                    </Box>
                </Box>
            )}

            {viewMode === "table" && (
                <Box>
                    <Box className="d-flex justify-content-between align-items-center mb-2">
                        <Typography variant="h6">
                            Loan Products
                        </Typography>
                        <Button
                            className="fs-size-12 paiy-blue text-white"
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                setViewMode("create");
                                setFormValues({}); // reset form
                            }}
                        >
                            Create Product
                        </Button>
                    </Box>

                    <LoanSetupTable
                        data={loanProductsArr}
                        columns={columns}
                        title="Loan Products"
                        formatRow={(row) => [
                            row?.lp?.productid,
                            row?.lp?.name,
                            row?.lp?.categoryid,
                            row?.lc?.category_name,
                            row?.lp?.currencycode
                        ]}
                        isEdit={true}
                        handleEdit={handleEdit}
                        viewLoanTypes={true}
                        handleViewLoanTypes={handleViewLoanTypes}
                        isDelete={true}
                        handleDelete={handleDeleteConfirmation}
                    />
                </Box>
            )}

            <BaseDrawer
                open={openLoanTypesDrawer}
                handleClose={() => setOpenLoanTypesDrawer(false)}
                height="85vh"
            >
                {
                    <Box className="loan-types-drawer-container">
                        <LoanTypes loanTypes={loanTypesArr} setAlert={setAlert} setAlertOpen={setAlertOpen} selectedProductId={selectedProductId} setOpenLoanTypesDrawer={setOpenLoanTypesDrawer} selectedProductId={selectedProductId} />
                    </Box>
                }
            </BaseDrawer>
        </Box>
    )
}

export default LoanProducts;
